<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.buildingManagement") }}</h1>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div class="mt-2" v-if="buildings.length > 0">
      <b-row class="pt-2">
        <b-col sm="4" class="mt-2">
          <b-form-select v-model="perPage" :options="options"></b-form-select>
        </b-col>
        <b-col sm="4" class="mt-2">
          <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
          <b-button variant="link" @click="resetTable()">{{ $t('action.reset') }}</b-button>
        </b-col>
        <b-col sm="4" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ rows }}</div>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col class="lgTable">
          <b-table id="BuildingTable" stacked="lg" bordered :fields="myfields" :items="items" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
            <template v-slot:cell(details)="row">
              <b-button v-if="user.role === 4" class="ml-2" size="sm" @click="editBuilding(row.item)">{{ $t("action.update") }}</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col sm="6" class="mt-2">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="BuildingTable"></b-pagination>
        </b-col>
      </b-row>

    </div>

    <div v-else>
      <div v-if="!spinner">
        <div v-if="buildings" class="text-center pt-2">{{ $t("label.empty") }}</div>
      </div>
    </div>

    <b-row v-if="!spinner" class="pt-4">
      <b-col class="mt-2">
        <b-button variant="success" v-if="user.role === 4" @click="addBuilding()">{{ $t("action.addBuilding") }}</b-button>
      </b-col>
    </b-row>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios';
import { globalF } from '../../Helpers';

export default {
  mixins: [globalF],
  data() {
    return {
      error: "",
      sortBy: 'NOMDIV',
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      search: "",
      allBuilding: [],
      buildings: [],
      selected: [],
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      spinner: false
    }
  },
  mounted() {
    this.ajaxCall();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.buildings;
      //return mydatalist;
      let search = this.search.toLowerCase();
      return mydatalist.filter(p => p.NOCIE.toString().toLowerCase().includes(search) || p.NODIV.toString().toLowerCase().includes(search) || p.NOMDIV.toLowerCase().includes(search) || p.Creation.toLowerCase().includes(search));
    },
    myfields: function () {
      return [
        { key: 'NOCIE', sortable: true, label: "NOCIE" },
        { key: 'NODIV', sortable: true, label: "NODIV" },
        { key: 'NOMDIV', sortable: true, label: "NOMDIV" },
        { key: 'Creation', sortable: true, label: this.$t('label.date') },
        { key: 'details', label: this.$t('label.detail') }
      ]
    },
    user: function () {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    editBuilding: function (build) {
      this.$store.commit('addBuildingToEdit', build);
      this.$emit('changePage', 'AddEditBuilding');
    },
    addBuilding: function () {
      this.$store.commit('addBuildingToEdit', null);
      this.$emit('changePage', 'AddEditBuilding');
    },
    getbuilding: function () {
      return null;
    },
    ajaxCall() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios.post(url, { request: "getAllActiveBuilding" }, { headers: { 'Content-Type': 'application/json' } })
          .then((response) => {
            this.spinner = false;
            this.$store.commit('setReloadValue', false);
            this.$store.commit('addUserList', response.data.users);
            this.$store.commit('addUsersBuilding', response.data.userBuilding);
            this.allBuilding = response.data.buildings;
            this.buildings = response.data.buildings;
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t('info.errorgeneric');
          });
      });


    },
    resetTable: function () {
      this.$store.commit('setSearch', "");
      this.search = "";
      this.buildings = this.allBuilding;
    }
  }
}
</script>
